module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1307711746/src/src/app/common/auto-logout/auto-logout.component.html
// module id = ../../../../../src/app/common/auto-logout/auto-logout.component.html
// module chunks = main